module.exports = __webpack_public_path__ + "static/media/home.168b86c3.png";